import React from "react";

import { ReactComponent as RocketIcon } from "../../assets/rocket-emoji.svg";
import profilePicUser1 from "../../assets/nikhil-linkedin.jpeg";
import profilePicUser2 from "../../assets/amit.jpeg";

import "./Testimony.scss";
import EndoresementItem from "../EndorsementItem/EndoresementItem";

const Testimony = () => {
  return (
    <div className="testimony">
      <p>
        Endorsements That Build Trust <RocketIcon className="svg-title-icon" />
      </p>
      <div className="content">
        <EndoresementItem
          profilePic={profilePicUser1}
          name="Nikhil Pujari"
          content="I had the pleasure of working with Swapnil for over three years, and during that time, he consistently proved himself to be an exceptional developer. No matter what challenge or task was thrown at him, he tackled it with skill and determination"
          mentorUrl="https://www.linkedin.com/in/nkhpujari"
        />
        <EndoresementItem
          profilePic={profilePicUser2}
          name="Amit Bhattacharjee"
          content="Swapnil mentored and co developed with me during our time in peoplegrove. He is undoubtedly one of the best mentors/senior you could have. No matter how complicated the problem is Swapnil always"
          mentorUrl="https://www.linkedin.com/in/amit-bhattacharjee-93b607157"
        />
      </div>
      <div className="read-more">
        <a href="https://www.linkedin.com/in/shah-swapnil/details/recommendations">
          <p>Read More Kudos on LinkedIn</p>
        </a>
      </div>
    </div>
  );
};

export default Testimony;
